import React, { useRef } from 'react';

import { bemCssModules, getTestId } from '@utils';
import { useModal } from '@utils/hooks';

import { CryptoCurrencyEnum, CurrencyEnum, FiatCurrencyEnum } from '@modules/global/types';

import Dropdown from '@components/Dropdown';

import Border from './border.svg';
import BorderLoading from './border_loading.svg';

import style from './CurrencySelect.scss';

const cn = bemCssModules(style, 'CurrencySelect');
const ti = getTestId('CurrencySelect');

export type TCurrencySelect = {
  className?: string;
  currencies: {
    value: CurrencyEnum;
    label: CurrencyEnum;
  }[];
  value: string;
  onClick: (currency: CryptoCurrencyEnum | FiatCurrencyEnum) => void;
  disabled?: boolean;
  network?: string;
  error?: boolean;
  isLoading?: boolean;
  testId?: string;
};

const CurrencySelect: React.FC<TCurrencySelect> = props => {
  const { className, currencies, value, onClick, disabled, network, error, isLoading, testId } =
    props;

  const buttonRef = useRef<HTMLButtonElement>(null);
  const modalRef = useRef<HTMLDivElement>(null);
  const desktopSelectRef = useRef<HTMLDivElement>(null);
  const [isOpen, setIsOpen] = useModal([modalRef, desktopSelectRef]);

  const toggleCurrencyModalOpen = () => setIsOpen(!isOpen);

  const handleClick = (currency: CryptoCurrencyEnum | FiatCurrencyEnum) => {
    onClick(currency);
    setIsOpen(false);
  };

  const isDisabled = disabled || currencies.length < 2;

  return (
    <div className={cn(null, [className])}>
      <button
        ref={buttonRef}
        className={cn('button')}
        type="button"
        onClick={toggleCurrencyModalOpen}
        disabled={isDisabled}
        data-testid={ti(testId)}
      >
        <div
          className={cn('button-content', { error, basedToken: !!network })}
          data-network={network}
        >
          {isLoading ? <BorderLoading /> : !isDisabled && <Border />}
          <span>{value}</span>
        </div>
      </button>
      <Dropdown
        className={cn('modal')}
        data={currencies}
        controller={buttonRef}
        onChange={currency => handleClick(currency.value)}
      />
    </div>
  );
};

export default CurrencySelect;
